import styled from 'styled-components';

export const MainWrapper = styled.div`
  width: 100%;
`;

export type MainContentWrapperProps = {
  isSidebarExpanded: boolean
  visible: boolean
};

export const MainContentWrapper = styled.div<MainContentWrapperProps>`
  background-color: ${({ visible }) => visible ? '#E9ECEF' : '#FFF'};
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  padding: ${({ visible }) => (visible ? '64px 0 16px' : '0')};

  @media (min-width: 1025px) {
    padding: ${({ visible, isSidebarExpanded }) =>
    visible && isSidebarExpanded
      ? '64px 0 0 240px;'
      : visible && !isSidebarExpanded
        ? '64px 0 24px 80px;'
        : '0'};
  }
  transition: padding 0.2s;
`;
